export * from './lib/interfaces/color-picker-form-field-config.interface';
export * from './lib/form-color-picker.module';
